import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import React__default from "react";
import classnames from "../../utils/classnames.js";
import Button from "../Button/Button.js";
import Checkbox from "../Checkbox/Checkbox.js";
import Divider from "../Divider/Divider.js";
import Col from "../Grid/Col.js";
import Row from "../Grid/Row.js";
import './Benefits.css';import '../Grid/Grid.css';/* empty css                */
import Typography from "../Typography/Typography.js";
/* empty css              */
const Benefits = ({
  className,
  title,
  header,
  subtotal,
  footer,
  dividers,
  items,
  onSelectChange
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  if (!items.length) {
    return null;
  }
  const headerDividerWidth = ((_a = dividers == null ? void 0 : dividers.header) == null ? void 0 : _a.width) ?? "thick";
  const headerDividerColor = ((_b = dividers == null ? void 0 : dividers.header) == null ? void 0 : _b.color) ?? "dark";
  const headerDividerCurved = ((_c = dividers == null ? void 0 : dividers.header) == null ? void 0 : _c.curved) ?? true;
  const mainDividerWidth = (_d = dividers == null ? void 0 : dividers.main) == null ? void 0 : _d.width;
  const mainDividerColor = (_e = dividers == null ? void 0 : dividers.main) == null ? void 0 : _e.color;
  const mainDividerCurved = (_f = dividers == null ? void 0 : dividers.main) == null ? void 0 : _f.curved;
  const footerDividerWidth = (_g = dividers == null ? void 0 : dividers.footer) == null ? void 0 : _g.width;
  const footerDividerColor = ((_h = dividers == null ? void 0 : dividers.footer) == null ? void 0 : _h.color) ?? "dark";
  const footerDividerCurved = (_i = dividers == null ? void 0 : dividers.footer) == null ? void 0 : _i.curved;
  const handleSelectChange = (e, id) => {
    if (onSelectChange) {
      onSelectChange(e, id);
    }
  };
  return /* @__PURE__ */ jsxs("div", { className: classnames(`perxis-auto-benefits`, className), children: [
    !!title && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs(Row, { justify: "space-between", align: "middle", gutter: [0, "vertical-purple"], children: [
        /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsx(
          Typography.Title,
          {
            headingLevel: 3,
            level: "h2",
            color: "darkest",
            className: classnames("perxis-auto-benefits__title"),
            children: title.label
          }
        ) }),
        !!title.icon && /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsx(Typography.Text, { level: "h3", color: "darkest", className: classnames("perxis-auto-benefits__icon"), children: title.icon }) })
      ] }),
      /* @__PURE__ */ jsx(Divider, { width: headerDividerWidth, color: headerDividerColor, curved: headerDividerCurved })
    ] }),
    !!(header == null ? void 0 : header.length) && /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-benefits__header"), children: header.map((item) => /* @__PURE__ */ jsxs(Row, { justify: "space-between", align: "middle", gutter: [0, "vertical-purple"], children: [
      /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsxs(Typography.Title, { headingLevel: 5, level: "h5", className: classnames("perxis-auto-benefits__section-title"), children: [
        item.label,
        item.footnoteNumber && /* @__PURE__ */ jsx("sup", { children: item.footnoteNumber })
      ] }) }),
      /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsx(Typography.Title, { headingLevel: 5, level: "h4", className: classnames("perxis-auto-benefits__section-value"), children: item.value }) })
    ] }, item.id)) }),
    /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-benefits__items"), children: [
      !!header && /* @__PURE__ */ jsx(
        Divider,
        {
          width: mainDividerWidth,
          color: mainDividerColor,
          curved: mainDividerCurved,
          className: classnames("perxis-auto-benefits__items-first-divider")
        }
      ),
      items.map(({ id, label, value, disabled, selected, incompatible, footnoteNumber }) => /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-benefits__item"), children: [
        /* @__PURE__ */ jsxs(Row, { justify: "space-between", align: "top", gutter: [0, "vertical-purple"], children: [
          /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsxs(
            Checkbox,
            {
              disabled,
              onChange: (e) => handleSelectChange(e, id),
              checked: selected,
              className: classnames([
                "perxis-auto-benefits__item-checkbox",
                {
                  "perxis-auto-benefits__item--incompatible": incompatible
                }
              ]),
              children: [
                label,
                footnoteNumber && /* @__PURE__ */ jsx("sup", { children: footnoteNumber })
              ]
            }
          ) }),
          /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsx(
            Typography.Text,
            {
              level: "main",
              color: "darkest",
              className: classnames([
                "perxis-auto-benefits__item-value",
                {
                  "perxis-auto-benefits__item-value--disabled": disabled,
                  "perxis-auto-benefits__item--incompatible": incompatible
                }
              ]),
              children: value
            }
          ) })
        ] }, id),
        /* @__PURE__ */ jsx(
          Divider,
          {
            width: mainDividerWidth,
            color: mainDividerColor,
            curved: mainDividerCurved,
            className: classnames("perxis-auto-benefits__items-divider")
          }
        )
      ] }, id))
    ] }),
    !!(subtotal == null ? void 0 : subtotal.length) && /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-benefits__subtotal"), children: subtotal == null ? void 0 : subtotal.map((item, index) => /* @__PURE__ */ jsxs(React__default.Fragment, { children: [
      /* @__PURE__ */ jsxs(Row, { justify: "space-between", align: "middle", gutter: [0, "vertical-purple"], children: [
        /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsxs(
          Typography.Title,
          {
            headingLevel: 4,
            level: "h5",
            color: "darkest",
            className: classnames("perxis-auto-benefits__section-title"),
            children: [
              item.label,
              item.footnoteNumber && /* @__PURE__ */ jsx("sup", { children: item.footnoteNumber })
            ]
          }
        ) }),
        /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsx(Typography.Title, { headingLevel: 5, level: "h4", className: classnames("perxis-auto-benefits__section-value"), children: item.value }) })
      ] }),
      index + 1 < subtotal.length && /* @__PURE__ */ jsx(Divider, { width: mainDividerWidth, color: mainDividerColor, curved: mainDividerCurved })
    ] }, item.id)) }),
    !!footer && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        Divider,
        {
          width: footerDividerWidth,
          color: footerDividerColor,
          curved: footerDividerCurved,
          className: classnames("perxis-auto-benefits__last-divider")
        }
      ),
      /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-benefits__footer"), children: /* @__PURE__ */ jsxs(Row, { justify: "space-between", align: "middle", gutter: [0, "vertical-purple"], children: [
        /* @__PURE__ */ jsx(Col, { xs: { order: 1, span: 24 }, sm: { order: 0, span: 14 }, children: /* @__PURE__ */ jsx(Typography.Text, { level: "super-small", color: "dark-light", children: footer.text }) }),
        /* @__PURE__ */ jsx(Col, { xs: { order: 0, span: 24 }, sm: { order: 1, span: 10 }, children: /* @__PURE__ */ jsx(Row, { justify: { xs: "center", sm: "end" }, children: /* @__PURE__ */ jsx(Col, { children: footer.button && /* @__PURE__ */ jsx(
          Button,
          {
            icon: footer.button.icon,
            iconPosition: "right",
            type: "primary",
            onClick: footer.button.onClick,
            children: footer.button.title
          }
        ) }) }) })
      ] }) })
    ] })
  ] });
};
export {
  Benefits as default
};
//# sourceMappingURL=Benefits.js.map
